<!-- HEADER START -->
@if(isBrowser)
{
<div class="container-fluid">
  <div class="row">
    <div class="header">
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1 col-2 logo-col">
          <button class="btn navbar-toggler collapsed" tyspe="button" data-bs-toggle="collapse"
            data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="col-lg-4 col-md-3 col-sm-4 col-5" style="align-content: center;">
          <a routerLink="/"><img src="theme/images/logo.svg" class="logo logo-bounce" width="220"
              alt="KudosHub Technologies"></a>
        </div>
        <div class="col-lg-8  col-md-8 col-sm-7 col-5 text-end">
          @if (!isUserLoggedIn) {
          <button class="login-btn logo-bounce" routerLink="/login">
            <img _ngcontent-c1="" height="22" src="theme/images/log-icon.webp" width="22" alt="login-logo">
            LOGIN
          </button>
          }
          @if (!isUserLoggedIn) {
          <button class="get-started-btn logo-bounce" routerLink="/register"> <img src="../../theme/images/power.svg"
              alt="power"> GET STARTED</button>
          }
          @if (isUserLoggedIn) {
          <div>
            <figure class="log-icon2">
              Hi, {{userDetail?.first_name}}
              <div class="dropdown" style="z-index: 99999999;">
                <div class="caret" data-bs-toggle="dropdown"></div>
                <ul class="dropdown-menu">
                  <li>
                    <a routerLink="/dashboard"><img src="../../theme/images/dashboard-black.svg"
                        class="dropdown-menu-icon" alt="dashboard"> Dashboard</a>
                  </li>
                  <li>
                    <a href="javascript:;" (click)="logout()"><img src="../../theme/images/power-off-black.svg"
                        class="dropdown-menu-icon" alt="power-off"> Logout</a>
                  </li>
                  <img src="../../theme/images/users.svg" class="drop-down-bg-image" alt="users">
                </ul>
              </div>
            </figure>
          </div>
          }
        </div>
      </div>
      <div class="collapse" id="navbarNav">
        <!-- for mobile screen -->
        <ul class="topics-bullets nav nav-pills" role="tablist">
          <li class="getStarted topic-list" id="topic-list">
            <a href="#" routerLink="/docs" data-bs-toggle="pill" routerLinkActive="isActive"
              [routerLinkActiveOptions]="{ exact: true }"><span>Getting Started</span></a>
          </li>
          <li class="topic-list" id="topic-list">
            <a href="#" routerLink="./email-validation" data-bs-toggle="pill" routerLinkActive="isActive"><span>Email
                Validation</span></a>
          </li>
          <li class="topic-list">
            <a href="#" routerLink="./email-validation-api" data-bs-toggle="pill"
              routerLinkActive="isActive"><span>Email
                validation API</span></a>
          </li>
          <li class="topic-list">
            <a href="#" routerLink="./ai-email-scoring" data-bs-toggle="pill" routerLinkActive="isActive"><span>AI Email
                Scoring</span></a>
          </li>
          <li class="topic-list">
            <a href="#" routerLink="./ai-email-scoring-api" data-bs-toggle="pill" routerLinkActive="isActive"><span>AI
                Email Scoring API</span></a>
          </li>
        </ul>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>
<!-- HEADER END -->

<div class="container-fluid" id="allSection">
  <div class="row">
    <div class="col-xl-2 col-lg-3 col-md-2">
      <div class="left-section">
        <h2 class="topics-txt">TOPICS</h2>
        <section>
          <ul class="topics-bullets nav nav-pills" role="tablist">
            <li class="getStarted topic-list">
              <a href="#" routerLink="/docs" routerLinkActive="isActive" data-bs-toggle="pill"
                [routerLinkActiveOptions]="{ exact: true }"><span>Getting Started</span></a>
            </li>
            <li class="topic-list">
              <a href="#" routerLink="./email-validation" data-bs-toggle="pill" routerLinkActive="isActive"><span>Email
                  Validation</span></a>
            </li>
            <li class="topic-list">
              <a href="#" routerLink="./email-validation-api" data-bs-toggle="pill"
                routerLinkActive="isActive"><span>Email validation API</span></a>
            </li>
            <li class="topic-list">
              <a href="#" routerLink="./ai-email-scoring" data-bs-toggle="pill" routerLinkActive="isActive"><span>AI
                  Email Scoring</span></a>
            </li>
            <li class="topic-list">
              <a href="#" routerLink="./ai-email-scoring-api" data-bs-toggle="pill" routerLinkActive="isActive"><span>AI
                  Email Scoring API</span></a>
            </li>
          </ul>
        </section>
      </div>
    </div>
    <div class="col-xl-10 col-lg-8 col-md-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
}